import { DSSpacer, DSText } from '@zoe/ds-web'
import styled from 'styled-components'

import { LOCALE_US } from '@/types/locales'

import { DSLinkText } from '@/components/ds/LinkText/LinkText'

import { useCurrentLocale } from '@/lib/hooks/useCurrentLocale'

import { trackFooterClick } from './Footer'

const StyledMenuContainer = styled.div`
  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }
  li {
    transition: transform 0.3s ease-in-out;
    max-width: 200px;
    &:hover {
      transform: translateY(-2px);
    }
  }
`

export const FooterCompanyMenu: React.FC = () => {
  const { currentLocale } = useCurrentLocale()

  const handleCookiePreferencesClick = () => {
    trackFooterClick('Cookie preferences')
    // Open the cookie preferences dialog
    if (
      typeof window !== 'undefined' &&
      window['OneTrust'] &&
      typeof window['OneTrust'].ToggleInfoDisplay === 'function'
    ) {
      window['OneTrust'].ToggleInfoDisplay()
    }
  }

  return (
    <StyledMenuContainer>
      <DSText as="h5" variant="fluid-label-100" weight="semiBold" color="primary-inverse">
        Company
      </DSText>
      <DSSpacer size={16} direction="vertical" />
      <ul>
        <li>
          <DSLinkText href="/about-zoe" onPress={() => trackFooterClick('About us')}>
            <DSText as="span" weight="light" variant="fluid-label-100" color="primary-inverse">
              About us
            </DSText>
          </DSLinkText>
          <DSSpacer size={12} direction="vertical" />
        </li>
        <li>
          <DSLinkText
            href="https://www.notion.so/joinzoe/Work-at-ZOE-8b8954cb8b50419e8f7d87b9ea176e1f"
            onPress={() => trackFooterClick('Careers')}
          >
            <DSText as="span" weight="light" variant="fluid-label-100" color="primary-inverse">
              Careers
            </DSText>
          </DSLinkText>
          <DSSpacer size={12} direction="vertical" />
        </li>
        <li>
          <DSLinkText
            href={`/${currentLocale}/terms`}
            onPress={() => trackFooterClick('Terms of Service (Membership)')}
          >
            <DSText as="span" weight="light" variant="fluid-label-100" color="primary-inverse">
              Terms of Service (Membership)
            </DSText>
          </DSLinkText>
          <DSSpacer size={12} direction="vertical" />
        </li>
        <li>
          <DSLinkText
            href={`/${currentLocale}/daily30/terms`}
            onPress={() => trackFooterClick('Terms of Service (Daily30+)')}
          >
            <DSText as="span" weight="light" variant="fluid-label-100" color="primary-inverse">
              Terms of Service (Daily30+)
            </DSText>
          </DSLinkText>
        </li>
        <DSSpacer size={12} direction="vertical" />
        <li>
          <DSLinkText href="/privacy-policy" onPress={() => trackFooterClick('Privacy policy')}>
            <DSText as="span" weight="light" variant="fluid-label-100" color="primary-inverse">
              Privacy policy
            </DSText>
          </DSLinkText>
          <DSSpacer size={12} direction="vertical" />
        </li>
        <li>
          <DSLinkText href="/cookie-policy" onPress={() => trackFooterClick('Cookie policy')}>
            <DSText as="span" weight="light" variant="fluid-label-100" color="primary-inverse">
              Cookie policy
            </DSText>
          </DSLinkText>
          <DSSpacer size={12} direction="vertical" />
        </li>
        <li>
          <DSLinkText href="#" onPress={handleCookiePreferencesClick}>
            <DSText as="span" weight="light" variant="fluid-label-100" color="primary-inverse">
              Cookie preferences
            </DSText>
          </DSLinkText>
        </li>
        {currentLocale === LOCALE_US && (
          <>
            <li>
              <DSSpacer size={12} direction="vertical" />
              <DSLinkText
                href="/consumer-health-data-privacy-notice"
                onPress={() => trackFooterClick('Consumer Health Data Privacy Notice')}
              >
                <DSText as="span" weight="light" variant="fluid-label-100" color="primary-inverse">
                  Consumer Health Data Privacy Notice
                </DSText>
              </DSLinkText>
            </li>
            <li>
              <DSSpacer size={12} direction="vertical" />
              <DSLinkText
                href="https://privacy.zoe.com/zoe"
                onPress={() => trackFooterClick('Do not sell or share my personal information')}
              >
                <DSText as="span" weight="light" variant="fluid-label-100" color="primary-inverse">
                  Do not sell or share my personal information
                </DSText>
              </DSLinkText>
            </li>
          </>
        )}
      </ul>
    </StyledMenuContainer>
  )
}
